module.exports = __webpack_public_path__ + "img/dd-logo-toyota-w.0387f477.png";